import { publicAPI } from '../../../../requests';
import { z } from 'zod';
import { stripeIntentDto, UserInfo } from '@web/common';
import i18next from 'i18next';

export const requestQrToken = async (paymentId: string, hash: string) => {
  return await publicAPI.post(
    `/payment/confirmation/${paymentId}`,
    {},
    z.string(),
    { headers: { 'Client-Secret': hash } },
  );
};

export const requestPaymentIntent = async (
  orderData: UserInfo,
  authToken: string,
  deviceId?: string,
) => {
  const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
  return publicAPI.post(
    `/payment/intent`,
    JSON.stringify(orderData),
    stripeIntentDto,
    {
      headers: {
        ...headers,
        Device: deviceId,
        Locale: i18next.resolvedLanguage,
      },
    },
  );
};

export const requestDeviceAvailability = async (
  identifier: string,
  deviceId: string,
  hash: string,
) => {
  return await publicAPI.get(
    `/checks/status/${deviceId}`,
    z.object({
      isAvailable: z.boolean(),
      secondsSinceLastPing: z.number().nullable(),
    }),
    { headers: { identifier: identifier, 'Client-Secret': hash } },
  );
};
